export const GET_TRANSFER_LINE_ORDER_APPROVAL_REQUEST = 'GET_TRANSFER_LINE_ORDER_APPROVAL_REQUEST';
export const GET_TRANSFER_LINE_ORDER_APPROVAL_SUCCESS = 'GET_TRANSFER_LINE_ORDER_APPROVAL_SUCCESS';
export const GET_TRANSFER_LINE_ORDER_APPROVAL_FAILURE = 'GET_TRANSFER_LINE_ORDER_APPROVAL_FAILURE';

export const GET_TRANSFER_LINE_DOC_BY_ID_REQUEST = 'GET_TRANSFER_LINE_DOC_BY_ID_REQUEST';
export const GET_TRANSFER_LINE_DOC_BY_ID_SUCCESS = 'GET_TRANSFER_LINE_DOC_BY_ID_SUCCESS';
export const GET_TRANSFER_LINE_DOC_BY_ID_FAILURE = 'GET_TRANSFER_LINE_DOC_BY_ID_FAILURE';

export const GET_UNMASKING_APPROVAL_REQUEST = 'GET_UNMASKING_APPROVAL_REQUEST';
export const GET_UNMASKING_APPROVAL_SUCCESS = 'GET_UNMASKING_APPROVAL_SUCCESS';
export const GET_UNMASKING_APPROVAL_FAILURE = 'GET_UNMASKING_APPROVAL_FAILURE';

export const UPDATE_UNMASKING_APPROVAL_STATUS_REQUEST = 'UPDATE_UNMASKING_APPROVAL_STATUS_REQUEST';
export const UPDATE_UNMASKING_APPROVAL_STATUS_SUCCESS = 'UPDATE_UNMASKING_APPROVAL_STATUS_SUCCESS';
export const UPDATE_UNMASKING_APPROVAL_STATUS_FAILURE = 'UPDATE_UNMASKING_APPROVAL_STATUS_FAILURE';
